export default __webpack_public_path__ + "static/media/img6.14106b98.png";